(function() {
  var mouseX = 0, mouseY = 0;
  var allowClose = false;

  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }, true);

  function rectContains(rect, x, y) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function isInSafeZone(details) {
    var dr = details.getBoundingClientRect();
    if (rectContains(dr, mouseX, mouseY)) return true;
    var content = details.querySelector('.mega-menu__content');
    if (!content) return false;
    var cr = content.getBoundingClientRect();
    if (rectContains(cr, mouseX, mouseY)) return true;
    if (dr.bottom < cr.top) {
      var gapLeft = Math.min(dr.left, cr.left);
      var gapRight = Math.max(dr.right, cr.right);
      if (mouseX >= gapLeft && mouseX <= gapRight && mouseY >= dr.bottom && mouseY <= cr.top) {
        return true;
      }
    }
    return false;
  }

  function forceClose(details) {
    allowClose = true;
    details.removeAttribute('open');
    allowClose = false;
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  // Override at prototype level so it catches ALL details elements, even ones created after this script runs
  var origRemoveAttribute = Element.prototype.removeAttribute;
  Element.prototype.removeAttribute = function(attr) {
    if (attr === 'open' && !allowClose && this.classList && this.classList.contains('mega-menu')) {
      if (isInSafeZone(this)) return;
    }
    return origRemoveAttribute.call(this, attr);
  };

  function init() {
    var megaMenus = Array.prototype.slice.call(document.querySelectorAll('details.mega-menu'));
    if (!megaMenus.length) return;

    megaMenus.forEach(function(details) {
      details.addEventListener('mouseenter', function() {
        megaMenus.forEach(function(d) {
          if (d !== details && d.hasAttribute('open')) forceClose(d);
        });
        details.setAttribute('open', '');
        var s = details.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      });
    });

    document.addEventListener('mousemove', function() {
      megaMenus.forEach(function(details) {
        if (details.hasAttribute('open') && !isInSafeZone(details)) {
          forceClose(details);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();